import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap, take} from 'rxjs/internal/operators';
import {catchError, map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';
import {LoadSupportUsersFailAction, LoadSupportUsersSuccessAction, supportUsersActionTypes} from '../actions/support-users';
import {SupportUsersService} from '../services/support-users.services';
import {SupportUsers} from '../models/support-users';
import {L10nTranslationService} from 'angular-l10n';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class SupportUsersEffect extends BaseEffect {

  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(supportUsersActionTypes.LOAD),
      debug('Load supportUsers action received;'),
      switchMap(() => {
        const cacheKey = 'supportUsers';
        const cached = this.apiCacheService.get<SupportUsers[]>(cacheKey);

        if (cached) {
          return of(new LoadSupportUsersSuccessAction(cached));
        }

        return this.supportUsersService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<SupportUsers>>) => {
            const users = payload.data.array;
            this.apiCacheService.set(cacheKey, users);
            return new LoadSupportUsersSuccessAction(users);
          }),
          catchError(res => this.catchResponseError(res))
        );
      }),
      take(1)
    );
  });


  loadFail$ =  createEffect(() => { return this.actions$.pipe(ofType(supportUsersActionTypes.LOAD_FAIL),
    debug('Load supportUsers fail action received.'),
    map((err: LoadSupportUsersFailAction ) =>
      error(this.translation.translate('CULTURES_LOAD_ERROR') + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))
    ))
  });

  constructor(private actions$: Actions,
              private apiCacheService: ApiCacheService ,
              private translation: L10nTranslationService,
              private supportUsersService: SupportUsersService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadSupportUsersFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadSupportUsersFailAction(response['error'].message);
  }
}
